import React, { useEffect, useState } from 'react'
import { enqueueNotification } from '../../../redux/slices/notificationsSlice'
import { Form } from 'react-final-form'
import { getCurrentDate } from '../../../utils/general'
import { useDispatch, useSelector } from 'react-redux'
import { useReportsSalesMutation } from '../../../services'
import Header from './components/Header/Header'
import { convertStringToDate } from '../../../utils/dateUtils'
import FilteringModal from './components/FilteringModal/FilteringModal'
import SalesTableBlock from './components/SalesTableBlock/SalesTableBlock'
import { UspReportSalesResult } from '../../../models'
import { useNavigate } from 'react-router-dom'
import { getUserAccessRights } from '../../../redux/slices/authSlice'
import { appRoute } from '../../../constants'
import { Card, Container } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'

const Sales = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userAccess = useSelector(getUserAccessRights)
  const [showTable, setShowTable] = useState(false)
  const [openFilterModal, setOpenFilterModal] = useState(true)
  const [formValues, setFormValues] = useState<any>(null)

  const [filterSales, { data: filterData, isSuccess: filterIsSuccess, isLoading: filterIsLoading }] = useReportsSalesMutation()

  const handleOpenFilterModal = () => setOpenFilterModal(true)
  const handleCloseFilterModal = () => setOpenFilterModal(false)

  const handleSubmit = (values: any) => {
    const jsonBranchList = values?.Branch?.map((item: any) => ({ BranchID: item?.BranchID }))
    const jsonLenderList = values?.Lender?.map((item: any) => ({ LenderID: item?.ID }))
    const jsonDealTypeList = values?.Deal?.map((item: any) => ({ DealType: item?.ID }))
    const jsonSalespersonList = values?.Salesperson?.map((item: any) => ({ SalespersonUserID: item?.UserID }))
    filterSales({
      uspReportSales: {
        asOfDate: getCurrentDate(),
        startDate: convertStringToDate(values.StartDate),
        endDate: convertStringToDate(values.EndDate),
        isIncludeDeliveredDeals: values.isIncludeDeliveredDeals || false,
        isBasedOnFinalizedDate: values.isBasedOnFinalizedDate || false,
        jsonBranchList: jsonBranchList || null,
        jsonLenderList: jsonLenderList || null,
        jsonDealTypeList: jsonDealTypeList || null,
        jsonSalespersonList: jsonSalespersonList || null,
      },
    })
    setFormValues(values)
  }

  useEffect(() => {
    if (filterIsSuccess) {
      handleCloseFilterModal()
      setShowTable(true)
      dispatch(enqueueNotification({ message: 'Success' }))
    }
  }, [filterIsSuccess])

  useEffect(() => {
    if (!userAccess.CanAccessSalesInsights) {
      dispatch(
        enqueueNotification({
          message:
            'Access Denied: Sorry, your current access rights do not permit you to enter this section. If you believe you should have access, please contact your system administrator or help desk for assistance.',
          options: { variant: 'error' },
        }),
      )
      navigate(appRoute.Home)
    }
  }, [userAccess, appRoute])

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CustomBreadcrumbs
        heading='Reports'
        links={[
          {
            href: appRoute.Insights,
            name: 'List',
          },
          {
            name: 'Sales',
          },
        ]}
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Card
        sx={{
          height: { xs: 800, md: 2 },
          flexGrow: { md: 1 },
          display: { md: 'flex' },
          flexDirection: { md: 'column' },
        }}
      >
        <Form onSubmit={handleSubmit} keepDirtyOnReinitialize initialValues={{ isIncludeDeliveredDeals: false, isBasedOnFinalizedDate: false }}>
          {({ handleSubmit }: any) => (
            <form onSubmit={handleSubmit}>
              {showTable && <Header handleOpenFilterModal={handleOpenFilterModal} filterData={filterData as UspReportSalesResult[]} />}
              <FilteringModal formValues={formValues} open={openFilterModal} handleClose={handleCloseFilterModal} />
              {showTable && <SalesTableBlock filterData={filterData as UspReportSalesResult[]} isLoading={filterIsLoading} />}
            </form>
          )}
        </Form>
      </Card>
    </Container>
  )
}

export default Sales
